import React, { FC } from "react";
import { Table } from "react-bootstrap";
import { Decimal } from "../../types/custom/Decimal";

interface Props {
    available: Decimal;
    used: Decimal;
    remaining: Decimal;
}

export const DefinedContributionsTable: FC<Props> = ({ available, used, remaining }) => {
    return (
        <Table striped>
            <thead>
                <tr>
                    <th className="e-header" colSpan={2}>Defined Contributions</th>
                </tr>
                <tr>
                    <th className="e-header text-left font-weight-bold">Available</th>
                    <th className="e-header text-right">${available.toFixed(2)}</th>
                </tr>
                <tr>
                    <th className="e-header text-left font-weight-bold">Used</th>
                    <th className="e-header text-right">${used.toFixed(2)}</th>
                </tr>
                <tr>
                    <th className="e-header text-left font-weight-bold">Remaining</th>
                    <th className="e-header text-right">${remaining.toFixed(2)}</th>
                </tr>
            </thead>
        </Table>
    );
};
